// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlkb7n{flex-grow:1}
._1e0c1txw{display:flex}
._1o9zkb7n{flex-shrink:1}
._2lx21bp4{flex-direction:column}
._4t3iidpf{height:0}
._i0dl1wug{flex-basis:auto}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/picker/EmojiPickerTabPanel.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,YAAY;AACvB,WAAW,aAAa;AACxB,WAAW,qBAAqB;AAChC,WAAW,QAAQ;AACnB,WAAW,eAAe","sourcesContent":["._16jlkb7n{flex-grow:1}\n._1e0c1txw{display:flex}\n._1o9zkb7n{flex-shrink:1}\n._2lx21bp4{flex-direction:column}\n._4t3iidpf{height:0}\n._i0dl1wug{flex-basis:auto}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
